import { defineComponent, watch, onMounted } from 'vue';
import roomStore from "@shared/libs/store/room-store";
import { ScreenMode } from "@shared/libs/room-engine/types";
import $d from "@shared/libs/device";
import { feature } from "@shared/libs/feature-flags";
export default defineComponent({
  name: "App",
  computed: {
    ScreenMode: () => ScreenMode
  },

  setup() {
    onMounted(() => {
      const loadingEl = document.getElementById("loading");

      if (!loadingEl) {
        return;
      }

      if (loadingEl.parentNode !== null) {
        loadingEl.parentNode.removeChild(loadingEl);
      }
    });
    const room = roomStore.state;
    document.body.classList.add("portrait");

    if ($d.isTablet) {
      document.body.classList.add('tablet');
    }

    watch(() => room.screenMode, mode => {
      document.body.classList.remove("portrait");
      document.body.classList.remove('landscape');
      document.body.classList.remove('fake-landscape');
      document.body.classList.remove('dark');

      if (mode === ScreenMode.LANDSCAPE) {
        document.body.classList.add('landscape');
        document.body.classList.add('dark');
      } else if (mode === ScreenMode.FAKE_LANDSCAPE) {
        document.body.classList.add('landscape');
        document.body.classList.add('fake-landscape');
        document.body.classList.add('dark');
      } else {
        document.body.classList.add("portrait");
      }
    });
    watch(() => room.isTalking, isTalking => {
      if (isTalking) {
        document.body.classList.add("talking");
      } else {
        document.body.classList.remove("talking");
      }
    });
    watch(() => feature.talkerSideLayout, talkerSideLayout => {
      document.body.classList.remove("talker-on-top");
      document.body.classList.remove("talker-on-right");

      if (feature.talkerSideLayout) {
        document.body.classList.add("talker-on-right");
      } else {
        document.body.classList.add("talker-on-top");
      }
    }, {
      immediate: true
    });
    return {
      room: roomStore.state
    };
  }

});